module.exports = __webpack_public_path__ + "img/数景云平台1.89ff5be4.jpg";